/**
 * @generated SignedSource<<2e86b494590e811b7dd89b8c526b33c3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ClientRequest, ClientQuery } from 'relay-runtime';
export type useCurrentTabQuery$variables = Record<PropertyKey, never>;
export type useCurrentTabQuery$data = {
  readonly jira: {
    readonly centralizedFieldsAdminPage: {
      readonly currentTab: number;
    };
  };
};
export type useCurrentTabQuery = {
  response: useCurrentTabQuery$data;
  variables: useCurrentTabQuery$variables;
};

const node: ClientRequest = (function(){
var v0 = {
  "concreteType": "JiraQuery",
  "kind": "LinkedField",
  "name": "jira",
  "plural": false,
  "selections": [
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "concreteType": "CentralizedFieldsAdminPage",
          "kind": "LinkedField",
          "name": "centralizedFieldsAdminPage",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "currentTab"
            }
          ]
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "useCurrentTabQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": (v0/*: any*/),
        "action": "THROW",
        "path": "jira"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useCurrentTabQuery",
    "selections": [
      (v0/*: any*/)
    ]
  },
  "params": {
    "cacheID": "7b28aa57c4500b14735983aa36b48065",
    "id": null,
    "metadata": {},
    "name": "useCurrentTabQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4c65dcf049db471130db6c83cf11a74a";

export default node;
